/**
 * @generated SignedSource<<417ed974a29ecec51e750fb206c9619a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type ServicePageGearQuery$variables = Record<PropertyKey, never>;
export type ServicePageGearQuery$data = {
  readonly rentalItems: {
    readonly nodes: ReadonlyArray<{
      readonly assetTag: any;
      readonly category: EquipmentCategory;
      readonly dailyRate: any | null | undefined;
      readonly id: string;
      readonly image: any | null | undefined;
      readonly kitMembers: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly name: string;
    } | null | undefined> | null | undefined;
  };
};
export type ServicePageGearQuery = {
  response: ServicePageGearQuery$data;
  variables: ServicePageGearQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "AssetConnection",
    "kind": "LinkedField",
    "name": "rentalItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dailyRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kitMembers",
            "plural": true,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "rentalItems(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ServicePageGearQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ServicePageGearQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eeede89b27c0848070c5c642f5a0703e",
    "id": null,
    "metadata": {},
    "name": "ServicePageGearQuery",
    "operationKind": "query",
    "text": "query ServicePageGearQuery {\n  rentalItems(first: 200) {\n    nodes {\n      id\n      assetTag\n      name\n      category\n      image\n      dailyRate\n      kitMembers {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0ebb81be051219dd655cf875bcc4d27";

export default node;
